

















































































import Vue from "vue";
// import Component from 'vue-class-component'
import { Component, Prop } from "vue-property-decorator";
import { Variation } from "../../types/NewResults";

// The @Component decorator indicates the class is a Vue component
@Component({
  // All component options are allowed in here
  template: '<button @click="onClick">Click!</button>'
})
export default class VariationGraph extends Vue {
  @Prop() private duration!: Number;
  @Prop() private variation!: Variation[];
  private segmentLength: Number = 0;
  private maxwidth = 246;
  private created() {
    this.segmentLength = this.maxwidth / this.variation.length;
    console.log(this.segmentLength);
  }

  private getHeight(variation: Variation) {
    switch (variation) {
      case Variation.Bad:
        return 61;
        break;
      case Variation.Medium:
        return 31;
        break;
      default:
        return 1;
        break;
    }
  }
  private getColor(variation: Variation) {
    switch (variation) {
      case Variation.Bad:
        return "#F74657";
        break;
      case Variation.Medium:
        return "#FFCC00";
        break;
      case Variation.Good:
        return "#38D17A";
        break;
      default:
        return "transparent";
        break;
    }
  }
}
